/** https://docs.tsafe.dev/objectKeys */
function objectKeys(o) {
    return Object.keys(o);
}

export { objectKeys };
//# sourceMappingURL=objectKeys.mjs.map
